module.exports = __webpack_public_path__ + "img/PoliticsInformation.190f26a9.svg";